export const getCurrentTime = () => {
  const currentdate = new Date();

  return currentdate.toString();
};

export function addMinutes(date: Date, minutes: number) {
  return new Date(date.getTime() + minutes * 60000);
}
